<p>admin-buy works!</p>
